import { PageType } from "@product/scmp-sdk";

export const pathname = "/topic-collection";

export const page = {
  route(query: QueryParameters<{ entityId: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.TopicCollection },
    };
  },
};
